import TeamsContainer from "./TeamsContainer";
export default TeamsContainer;
